// Formats any date value to mm/dd/yyyy with zero-padded month/day.
// Handles ISO strings (yyyy-mm-dd...) by reading parts (no timezone shift)
// and other formats (e.g. "1/24/1989") via Date parsing.
const pad = (n) => String(n).padStart(2, "0");

export function formatDate(v) {
  if (!v) return "—";
  const s = String(v).trim();
  if (!s) return "—";
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`;
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
}

// mm/dd/yyyy, h:mm AM/PM for timestamps.
export function formatDateTime(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()} ${h}:${pad(d.getMinutes())} ${ampm}`;
}
